<template>
  <tr
    class="clickable"
    @click="$emit('view', yachtModel)"
  >
    <td
      colspan="2"
      class="pa-0"
    >
      <v-row
        no-gutters
        align="center"
      >
        <v-col
          style="flex: 0 0 80px"
          class="py-3 text-center"
        >
          <v-avatar
            color="grey lighten-3"
            size="55px"
          >
            <v-img
              v-if="yachtModel.main_image"
              :src="yachtModel.main_image.path"
              alt="Main image"
            />
          </v-avatar>
        </v-col>
        <v-col class="py-3 pl-5">
          <div class="font-weight-bold body-2 text-truncate">
            {{ yachtModel.full_name }}
          </div>
          <div class="grey--text text--lighten-1 text-truncate">
            ID {{ yachtModel.id }}
            &middot;
            <strong class="grey--text">
              {{ yachtModel.cabin_count_description }}
            </strong> cabins
            &middot;
            <strong class="grey--text">
              {{ yachtModel.berth_count_description }}
            </strong> RNOG
            &middot;
            {{ yachtModel.type.label }}
          </div>
          <div
            v-if="yachtModel.engines_description"
            class="grey--text text--lighten-1 text-truncate"
          >
            {{ yachtModel.engines_description }}
          </div>
          <div
            v-else
            class="error--text text--lighten-1"
          >
            Engines not set
          </div>
        </v-col>
      </v-row>
    </td>
    <td style="width: 1px">
      {{ yachtModel.model_year }}
    </td>
    <td
      style="width: 1px"
      class="text-no-wrap"
    >
      <flag
        :iso="yachtModel.country.code"
        :title="yachtModel.country.name"
        :squared="false"
        class="radius-3 mr-1 elevation-5"
      />
      <span>
        {{ yachtModel.country.name }}
      </span>
    </td>

    <td
      style="width: 1px"
      class="text-no-wrap"
    >
      {{ yachtModel.sale_price | currency(yachtModel.currency) }}
    </td>
    <td
      class="text-no-wrap"
      style="width: 1px"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            color="primary"
            small
            v-on="on"
            @click.stop.prevent="$emit('generate-offer', yachtModel)"
          >
            <v-icon small>
              assignment
            </v-icon>
          </v-btn>
        </template>
        Generate Offer (Annex 1)
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            color="primary"
            small
            v-on="on"
            @click.stop.prevent="$emit('start-sales', yachtModel)"
          >
            <v-icon small>
              add_shopping_cart
            </v-icon>
          </v-btn>
        </template>
        Start Sales
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
  import { sortBy } from 'lodash'
  import YachtModel from '@/models/YachtModel'

  export default {
    name: 'YachtModelPricelistRow',
    props: {
      yachtModel: {
        type: Object,
        required: true
      }
    },
    computed: {
      countries() {
        return sortBy(this.$store.getters['settings/charteringCountries'].data, 'name').map(c => {
          let yachtModelCountry = this.yachtModel.countries.find(pc => c.id === pc.id)

          return {
            ...c,
            included: !!yachtModelCountry,
            yachtModel: yachtModelCountry
          }
        })
      },
      requiredYachtEquipmentPackCategoriesCount: function () {
        return this.$store.state.settings.equipmentPackCategories.data.filter(c => c.required).length
      }
    },
    created() {
      this.yachtModelStatuses = YachtModel
    }
  }
</script>
